(() => {
  const headers = document.querySelectorAll('[data-kos-shell-header]');
  if (!headers.length) return;

  const setScrollState = () => {
    headers.forEach((header) => header.classList.toggle('is-scrolled', window.scrollY > 20));
  };

  const closeNav = (header) => {
    header.classList.remove('is-nav-open');
    const toggle = header.querySelector('[data-kos-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('kos-nav-open');
  };

  headers.forEach((header) => {
    const toggle = header.querySelector('[data-kos-nav-toggle]');
    if (toggle && toggle.dataset.bound !== 'true') {
      toggle.dataset.bound = 'true';
      toggle.addEventListener('click', () => {
        const open = !header.classList.contains('is-nav-open');
        header.classList.toggle('is-nav-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('kos-nav-open', open);
      });
    }

    header.querySelectorAll('[data-kos-mobile-nav] a').forEach((link) => link.addEventListener('click', () => closeNav(header)));

    header.querySelectorAll('[data-kos-shell-santa]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        let handled = false;
        const fallback = button.dataset.fallbackUrl || '/pages/estimate';
        window.dispatchEvent(new CustomEvent('kingdom:santa:open', {
          detail: { source: 'kingdom-os-header', button, markHandled: () => { handled = true; } }
        }));
        window.setTimeout(() => { if (!handled) window.location.assign(fallback); }, 120);
      });
    });
  });

  window.addEventListener('scroll', setScrollState, { passive: true });
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') headers.forEach(closeNav);
  });
  setScrollState();
})();
